module.exports = __webpack_public_path__ + "static/media/shareAdd.41922d4e.jpg";